import React from 'react';
import { MdOutlineDelete } from "react-icons/md";
import styles from '../assets/css/Transaction.module.css'; // Import the SAME CSS module

// Function to format game type
const formatGameType = (type) => {
    switch (String(type)) {
        case "1": return "JODI";
        case "2": return "ANDER H";
        case "3": return "BAHAR H";
        // Add more types as needed
        default: return type || "N/A"; // Return original type or N/A
    }
};

// Function to format date
const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    try {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = String(date.getFullYear()).slice(-2); // Last 2 digits of year
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        return `${day}/${month}/${year} ${hours}:${minutes}`;
    } catch (error) {
        console.error("Error formatting date:", error);
        return dateString;
    }
};

const MarketTable = ({ data, purpose, Oncancelfun }) => {
  // Destructure data with defaults
  const {
    game_name = "N/A",
    type = "",
    game_number = "N/A",
    created_at = "",
    money = 0,
    isResult = "0",
    id = null // Bet ID for cancellation
  } = data || {};

  const canCancel = purpose === "market" && String(isResult) === "0" && id !== null;
  const formattedNumber = String(game_number).padStart(2, '0'); // Pad game number

  return (
    // Use the card style defined in AghoriTransaction.module.css
    <div className={styles.historyCard}>
        <div className={styles.cardRow}>
            <span className={styles.gameDetails}>
                {game_name} <span className={styles.dimText}>({formatGameType(type)})</span> - <span className={styles.gameNumber}>{formattedNumber}</span>
            </span>
            <span className={`${styles.amount} ${styles.debit}`}>
                -₹{money}
            </span>
        </div>
        <div className={styles.cardRow}>
            <span className={styles.dateTime}>{formatDate(created_at)}</span>
            {canCancel ? (
                <button
                    className={styles.cancelButton}
                    onClick={() => Oncancelfun(id)}
                    aria-label="Cancel Bet"
                >
                    <MdOutlineDelete /> Cancel
                </button>
            ) : (
                <span className={styles.statusPlaceholder}></span>
            )}
        </div>
    </div>
  );
};

export default MarketTable;
